import { useEffect, useState } from 'react';

import isBrowser from '@/helpers/isBrowser';
import { SIZES, breakpoints } from '@/styles/media';

type UseIsMobile = (size?: SIZES) => boolean;

// TODO(will): This should have a generalized form.
const useIsMobile: UseIsMobile = (size = SIZES.sm) => {
  const breakpoint = breakpoints[size];

  // If breakpoint is 0 (xs), "mobile" should always be true
  const mediaQuery = breakpoint > 0 ? `(max-width: ${breakpoint - 1}px)` : undefined;

  const [isMobile, setIsMobile] = useState<boolean>(() => {
    if (!isBrowser()) return false;
    if (!mediaQuery) return true;
    return !!document.defaultView?.matchMedia(mediaQuery).matches;
  });

  useEffect(() => {
    if (!isBrowser()) {
      return undefined;
    }

    if (!mediaQuery) {
      // xs case, always true
      setIsMobile(true);
      return undefined;
    }

    const mql = document.defaultView?.matchMedia(mediaQuery);

    // Initialize value on mount and when breakpoint changes
    setIsMobile(!!mql?.matches);

    const handler = (event: MediaQueryListEvent): void => {
      setIsMobile(event.matches);
    };

    mql?.addEventListener('change', handler);

    return () => {
      mql?.removeEventListener('change', handler);
    };
  }, [mediaQuery]);

  return isMobile;
};

export default useIsMobile;
export { SIZES };
